module.exports = __webpack_public_path__ + "static/media/186-gabon.6ce3ea9c.svg";